export default __webpack_public_path__ + "static/media/icon_target_date-8-plus-days.9c1f8409.svg";